import React from 'react';
import NavigationPrompt from 'react-router-navigation-prompt';
import { ButtonMode } from '../Button';
import { StyledDialogButton } from '../Dialog/StyledDialogButton';
import { StyledPrompt } from './StyledPrompt';
import { divider } from '../../Styles/Colours';

type StyledNavigationPromptProps = {
    when: boolean;
    onSave?(): void;
    onCancel?(): void;
    onConfirm?(): void;
};

export class StyledNavigationPrompt extends React.Component<StyledNavigationPromptProps> {
    public handleSave = (onConfirm: () => void, onCancel: () => void) => () => {
        if (this.props.onSave) {
            this.props.onSave();
            onCancel();
        }
    };

    public handleCancel = (navigationPromptCancel: () => void) => () => {
        navigationPromptCancel();
        if (!!this.props.onCancel) {
            this.props.onCancel();
        }
    };

    public handleConfirm = (navigationPromptConfirm: () => void) => () => {
        navigationPromptConfirm();
        if (!!this.props.onConfirm) {
            this.props.onConfirm();
        }
    };

    public render() {
        if (!this.props.when) return null;

        return (
            <NavigationPrompt {...this.props} renderIfNotActive={false}>
                {({ onConfirm, onCancel }) => (
                    <StyledPrompt
                        open
                        title={'Save changes?'}
                        onCancel={onCancel}
                        actions={[
                            <StyledDialogButton
                                borderColour={divider}
                                title='Cancel'
                                key='keep-user-file-changes'
                                mode={ButtonMode.border}
                                width={112}
                                onClick={this.handleCancel(onCancel)}
                                testId='cancel'
                            >
                                Cancel
                            </StyledDialogButton>,
                            <StyledDialogButton
                                borderColour={divider}
                                title='Discard'
                                key='discard-user-file-changes'
                                onClick={this.handleConfirm(onConfirm)}
                                mode={ButtonMode.border}
                                width={112}
                                testId='discard'
                            >
                                Discard
                            </StyledDialogButton>,
                            this.props.onSave && (
                                <StyledDialogButton
                                    title='Save'
                                    key='save-user-file-changes'
                                    onClick={this.handleSave(onConfirm, onCancel)}
                                    width={112}
                                    testId='save'
                                >
                                    Save
                                </StyledDialogButton>
                            )
                        ]}
                    >
                        Unsaved changes will be lost.
                    </StyledPrompt>
                )}
            </NavigationPrompt>
        );
    }
}
